import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TableCard } from "@/components/ui/table-card";
import { Button } from "@/components/ui/button";
import { ReportStatusBadge } from "./ReportStatusBadge";
import type { AdminReportListItem } from "@/types";

function formatDateTime(dateStr: string) {
  return new Intl.DateTimeFormat("pl-PL", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(dateStr));
}

function truncate(text: string, max = 80) {
  if (text.length <= max) return text;
  return text.slice(0, max).trimEnd() + "…";
}

interface Props {
  reports: AdminReportListItem[];
  onOpen: (id: string) => void;
}

export function ReportTable({ reports, onOpen }: Props) {
  return (
    <TableCard>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-44">Utworzono</TableHead>
            <TableHead>Zgłaszający</TableHead>
            <TableHead>Wydarzenie</TableHead>
            <TableHead>Opis</TableHead>
            <TableHead className="w-32">Status</TableHead>
            <TableHead className="w-28" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {reports.length === 0 && (
            <TableRow>
              <TableCell colSpan={6} className="py-12 text-center text-sm text-muted-foreground">
                Brak zgłoszeń.
              </TableCell>
            </TableRow>
          )}
          {reports.map((r) => (
            <TableRow key={r.id} className="cursor-pointer" onClick={() => onOpen(r.id)}>
              <TableCell className="text-sm text-muted-foreground">
                {formatDateTime(r.createdAt)}
              </TableCell>
              <TableCell className="text-sm">{r.reporter.email}</TableCell>
              <TableCell className="text-sm">
                {r.event ? r.event.title : <span className="text-muted-foreground">—</span>}
              </TableCell>
              <TableCell className="text-sm text-muted-foreground max-w-md">
                {truncate(r.description)}
              </TableCell>
              <TableCell>
                <ReportStatusBadge status={r.status} />
              </TableCell>
              <TableCell>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    onOpen(r.id);
                  }}
                >
                  Otwórz
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableCard>
  );
}
